// Browser-safe entry — only client & shared exports (no Node/Express/chokidar).

// Client
export {
  addContextToAgentChat,
  appendAgentChatContextToMessage,
  clearAgentChatContext,
  formatAgentChatContextItemsForPrompt,
  listAgentChatContext,
  refreshAgentChatContext,
  removeAgentChatContextItem,
  sendToAgentChat,
  sendToAgentChatAndConfirm,
  setAgentChatContextItem,
  setContextToAgentChat,
  isEmbedMcpChatBridgeActive,
  useAgentChatContext,
  useAgentChatGenerating,
  useDevMode,
  useSendToAgentChat,
  AGENT_NATIVE_MCP_APP_HOST_MESSAGE_TYPES,
  getMcpAppHostContext,
  openMcpAppHostLink,
  requestMcpAppDisplayMode,
  sendMcpAppHostMessage,
  updateMcpAppModelContext,
  useMcpAppHostContext,
  CodeRequiredDialog,
  AgentNativeI18nProvider,
  LanguagePicker,
  getLocaleInitScript,
  localeDirection,
  normalizeLocaleCode,
  normalizeLocalePreference,
  normalizeLocalizationPreference,
  resolveLocaleFromCandidates,
  resolveLocaleFromPreference,
  useFormatters,
  useLocale,
  useT,
  DEFAULT_LOCALE,
  LOCALE_HYDRATION_GLOBAL,
  LOCALE_METADATA,
  LOCALE_STORAGE_KEY,
  SUPPORTED_LOCALES,
  useDbSync,
  useFileWatcher,
  useSession,
  cn,
  ApiKeySettings,
  type AgentChatContextItem,
  type AgentChatContextMessage,
  type AgentChatContextMutationOptions,
  type AgentChatContextRemoveOptions,
  type AgentChatContextSetOptions,
  type AgentChatContextState,
  type AgentChatMessage,
  type AgentNativeMcpAppHostMessageType,
  type McpAppDisplayMode,
  type McpAppHostChatMessage,
  type McpAppHostCapabilities,
  type McpAppHostContext,
  type McpAppHostContextSnapshot,
  type McpAppModelContextContentPart,
  type McpAppModelContextUpdate,
  type CodeRequiredDialogProps,
  type AuthSession,
  type UseAgentChatContextResult,
  type AgentNativeI18nCatalog,
  type AgentNativeI18nProviderProps,
  type LocaleCode,
  type LocaleHydrationPayload,
  type LocaleMessages,
  type LocaleMetadata,
  type LocalePreference,
  type LocalizationPreference,
} from "./client/index.js";

// Shared (isomorphic)
export { agentChat } from "./shared/index.js";

// Pure utilities (no Node.js deps — safe for browser and SSR)
export { parseArgs, camelCaseArgs } from "./scripts/parse-args.js";

// defineAction — used by template actions, no Node.js deps
export {
  defineAction,
  AgentActionStopError,
  isAgentActionStopError,
  type ActionHttpConfig,
  type AgentActionStopOptions,
  MCP_APP_EXTENSION_ID,
  MCP_APP_MIME_TYPE,
  MCP_APP_RESOURCE_URI_META_KEY,
  type ActionMcpAppConfig,
  type ActionMcpAppCsp,
  type ActionMcpAppCspBuilder,
  type ActionMcpAppHtmlBuilder,
  type ActionMcpAppPermissions,
  type ActionMcpAppResourceConfig,
  type ActionMcpAppResourceMeta,
} from "./action.js";
export {
  normalizeUserProfileName,
  USER_PROFILE_SETTING_KEY,
  type UserProfile,
} from "./user-profile/index.js";
export {
  ACTION_CHAT_UI_DATA_CHART_RENDERER,
  ACTION_CHAT_UI_DATA_INSIGHTS_RENDERER,
  ACTION_CHAT_UI_DATA_TABLE_RENDERER,
  ACTION_CHAT_UI_DATA_WIDGET_RENDERER,
  ACTION_CHAT_UI_INLINE_EXTENSION_RENDERER,
  type ActionChatUIConfig,
} from "./action-ui.js";
export {
  DATA_CHART_WIDGET,
  DATA_INSIGHTS_WIDGET,
  DATA_TABLE_WIDGET,
  createDataChartWidgetResult,
  createDataInsightsWidgetResult,
  createDataTableWidgetResult,
  dataChartWidgetResultSchema,
  dataChartWidgetSchema,
  dataInsightsWidgetResultSchema,
  dataTableWidgetResultSchema,
  dataTableWidgetSchema,
  dataWidgetResultSchema,
  isDataChartWidget,
  isDataTableWidget,
  isDataWidgetResult,
  normalizeDataWidgetKind,
  normalizeDataWidgetResult,
  type DataChartSeriesDefinition,
  type DataChartWidget,
  type DataChartWidgetResult,
  type DataChartWidgetResultInput,
  type DataInsightsWidgetResult,
  type DataInsightsWidgetResultInput,
  type DataTableColumn,
  type DataTableWidget,
  type DataTableWidgetResult,
  type DataTableWidgetResultInput,
  type DataWidgetDisplay,
  type DataWidgetKind,
  type DataWidgetResult,
  type DataWidgetResultMetadata,
} from "./data-widgets/index.js";
export {
  embedApp,
  MCP_APP_REQUEST_ORIGIN_CSP_SOURCE,
  type EmbedAppOptions,
} from "./mcp/embed-app.js";
export {
  embedRoute,
  type EmbedRouteContext,
  type EmbedRouteOptions,
  type EmbedRoutePathBuilder,
  type EmbedRouteResult,
} from "./mcp/embed-route.js";
